/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export type CascaderExpandTrigger = 'click' | 'hover';
export type CascaderTriggerType = 'click' | 'hover';
export type CascaderSize = 'small' | 'large' | 'default';

export type CascaderFilter = (searchValue: string, path: CascaderOption[]) => boolean;
export type CascaderSorter = (a: CascaderOption[], b: CascaderOption[], inputValue: string) => number;
export type CascaderQuery = (searchValue: string, resolve, reject) => CascaderOption[];

export interface CascaderOption {
  value?: any; // tslint:disable-line:no-any
  label?: string;
  title?: string;
  disabled?: boolean;
  loading?: boolean;
  isLeaf?: boolean;
  parent?: CascaderOption;
  children?: CascaderOption[];

  [key: string]: any; // tslint:disable-line:no-any
}

export interface CascaderSearchOption extends CascaderOption {
  path: CascaderOption[];
}

export interface NzShowSearchOptions {
  filter?: CascaderFilter;
  sorter?: CascaderSorter;
  query?: CascaderQuery;
}

export function isShowSearchObject(options: NzShowSearchOptions | boolean): options is NzShowSearchOptions {
  return typeof options !== 'boolean';
}

/**
 * To avoid circular dependency, provide an interface of `CascaderComponent`
 * for `CascaderService`.
 */
export interface CascaderComponentAsSource {
  inputValue: string;
  nzShowSearch: NzShowSearchOptions | boolean;
  nzLabelProperty: string;
  nzValueProperty: string;
  nzChangeOnSelect: boolean;

  nzChangeOn?(option: CascaderOption, level: number): boolean;

  // tslint:disable-next-line:no-any
  nzLoadData?(node: CascaderOption, index?: number): PromiseLike<any>;
}
